import { memo } from "react";

import classes from "./Menu.module.css";

import DrinkCardSmall from "../../components/General_Elements/DrinkCardSmall/DrinkCardSmall";
import LoadingSpinner from "../../UI/LoadingSpinner";

import { useCocktails } from "../../store/CocktailContext"

// list all all cocktail from db
const Menu = () => {
  const { loadedCocktails } = useCocktails();

  // map all the cocktails fetched from the backend to DrinkCardSmall
  let drinkItems;
  if (loadedCocktails) {
    drinkItems = loadedCocktails.map((cocktail) => {
      return <DrinkCardSmall key={cocktail._id} drink={cocktail} />;
    });
  }

  return (
        <div
          className={classes.page}
        >
          {drinkItems ? (
            <div className={classes.menu_container}>
              <ul className={classes.menu}> {drinkItems} </ul>
            </div>
          ) : (
            <LoadingSpinner asOverlay />
          )}
        </div>
  );
};

export default memo(Menu);
